import React from "react";

interface ILogomark extends React.SVGProps<SVGSVGElement> {
  darkTheme?: boolean;
  className?: string;
  leftClassName?: string;
  rightClassName?: string;
  colorClassName?: string; // provide if you want the same color for both sides
}

const Logomark = ({
  leftClassName = "",
  rightClassName = "",
  darkTheme,
  className = "",
  colorClassName,
  ...props
}: ILogomark) => {
  if (darkTheme) rightClassName = rightClassName + " fill-white";

  return (
    <svg
      width="101"
      height="116"
      viewBox="0 0 101 116"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        className={colorClassName || leftClassName || "fill-odfblue"}
        d="M0.205078 0V30.02C14.8351 30.02 28.1451 41.15 28.1451 57.96C28.1451 74.77 14.8351 85.79 0.205078 85.79V115.79C30.5851 115.79 58.2151 92.68 58.2151 58.01C58.2151 23.34 30.5751 0 0.205078 0Z"
      />
      <path
        className={colorClassName || rightClassName || "fill-black"}
        d="M100.085 29.97V0C79.1251 0 59.9351 9.86999 49.3851 26.96C54.7951 35.65 57.9851 46.15 57.9851 58.01C57.9851 69.87 54.7251 80.46 49.2151 89.17C59.1951 105.51 77.4351 115.72 100.075 115.79V85.76C88.2651 84.95 80.0451 78.54 76.9651 68.63H100.075V48.11H76.7251C80.1851 35.2 89.9451 30.18 100.075 29.96L100.085 29.97Z"
      />
    </svg>
  );
};

export default Logomark;
